var map = {
	"./arrow-down-blue.svg": 1012,
	"./arrow-down-grey.svg": 1013,
	"./arrow-right-white.png": 1014,
	"./arrow-right.svg": 1015,
	"./avax-logo.png": 161,
	"./big_unicorn.png": 1016,
	"./binance-coin-logo.webp": 274,
	"./binance-logo.png": 292,
	"./blue-loader.svg": 58,
	"./busd-logo.png": 276,
	"./circle-grey.svg": 166,
	"./circle.svg": 293,
	"./coinbaseWalletIcon.svg": 162,
	"./crosschain/wBTC.png": 275,
	"./crosschain/wDAI.png": 277,
	"./crosschain/wETH.png": 1017,
	"./crosschain/wUSDC.png": 278,
	"./crosschain/wUSDT.png": 279,
	"./crosschain/zBTC.png": 280,
	"./crosschain/zDAI.png": 281,
	"./crosschain/zETH.png": 282,
	"./crosschain/zUSDC.png": 283,
	"./crosschain/zUSDT.png": 284,
	"./dropdown-blue.svg": 1018,
	"./dropdown.svg": 1019,
	"./dropup-blue.svg": 1020,
	"./ethereum-logo.png": 123,
	"./fortmaticIcon.png": 163,
	"./link.svg": 1021,
	"./logo-text-white.png": 1022,
	"./logo-zero-124.png": 285,
	"./logo-zero-512.png": 290,
	"./magnifying-glass.svg": 1023,
	"./menu.svg": 1024,
	"./metamask.png": 291,
	"./mountain.png": 288,
	"./mountain_wide.png": 287,
	"./noise.png": 289,
	"./plus-blue.svg": 1025,
	"./plus-grey.svg": 1026,
	"./polkadot-logo.png": 294,
	"./portisIcon.png": 164,
	"./question-mark.svg": 1027,
	"./question.svg": 1028,
	"./spinner.svg": 1029,
	"./token-list/lists-dark.png": 1030,
	"./token-list/lists-light.png": 1031,
	"./token-logo.png": 122,
	"./trustWallet.png": 1032,
	"./walletConnectIcon.svg": 165,
	"./x.svg": 1033,
	"./xl_uni.png": 1034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 263;